import React, { useState } from "react";
import { AgChartsReact } from "ag-charts-react";

function getData() {
  return [
    { type: "Open", count: 117 },
    { type: "On Hold", count: 90 },
    { type: "In Progress", count: 50 },
    { type: "Completed", count: 90 },
  ];
}

const data = getData();
const numFormatter = new Intl.NumberFormat('en-US');
const total = data.reduce((sum, d) => sum + d['count'], 0);

export default function ChartRequestStatus() {
    const [options, setOptions] = useState({
        autoSize: true,
        data,
        theme: {
            baseTheme: "ag-default-dark",
        },
        title: {
          text: 'Request by Status',
          fontSize: 18,
          spacing: 25,
          textAlign: 'left'
        },
        series: [
          {
            type: 'pie',
            calloutLabelKey: 'type',
            fillOpacity: 0.9,
            strokeWidth: 0,
            angleKey: 'count',
            sectorLabelKey: 'count',
            calloutLabel: {
              enabled: false,
            },
            sectorLabel: {
              color: 'white',
              fontWeight: 'bold',
              formatter: ({ datum, sectorLabelKey }) => {
                const value = datum[sectorLabelKey];
                return numFormatter.format(value);
              },
            },
            fills: [
              '#fb7451',
              '#f4b944',
              '#57cc8b',
              '#49afda',
              '#3988dc',
              '#72508c',
              '#b499b5',
              '#b7b5ba',
            ],
            innerRadiusRatio: 0.5,
            innerLabels: [
              {
                text: numFormatter.format(total),
                fontSize: 24,
                fontWeight: 'bold',
              },
              {
                text: 'Total',
                fontSize: 16,
              },
            ],
            highlightStyle: {
              item: {
                fillOpacity: 0,
                stroke: '#535455',
                strokeWidth: 1,
              },
            },
            tooltip: {
              renderer: ({ datum, calloutLabelKey, title, sectorLabelKey }) => {
                return {
                  title,
                  content: `${datum[calloutLabelKey]}: ${numFormatter.format(
                    datum[sectorLabelKey]
                  )}`,
                };
              },
            },
          },
        ],
      });
    
      return <AgChartsReact options={options} />;
}
